import { wagmiConfig } from '@/config/wagmi-config'
import { watchConnections, type GetConnectionsReturnType } from 'wagmi/actions'

export function waitForConnection(signal?: AbortSignal) {
	return new Promise<GetConnectionsReturnType>((resolve, reject) => {
		const unsubscribe = watchConnections(wagmiConfig, {
			onChange: connections => {
				if (connections.length) {
					resolve(connections)
					unsubscribe()
				}
			}
		})

		// If the connection is aborted, reject the promise and unsubscribe the listener
		signal?.addEventListener('abort', () => {
			reject('Connection aborted')
			unsubscribe()
		})
	})
}
